import React from 'react';

export default function StatCard({ color = 'green', label, value, sub, icon }) {
  return (
    <div className={`stat-card ${color}`}>
      <div className="stat-label">{label}</div>
      <div className="stat-value">{value}</div>
      {sub && <div className="stat-sub">{sub}</div>}
      {icon && <i className={`bi ${icon} stat-icon`} />}
    </div>
  );
}
